import { withSvgIcon } from './withSvgIcon';

export const MailWithArrow = withSvgIcon(
  <>
    <path
      d="M3 7V13C3 14.1046 3.89543 15 5 15H10M3 7V7C3 5.89543 3.89543 5 5 5H15C16.1046 5 17 5.89543 17 7V7M3 7L9.10557 10.0528C9.66863 10.3343 10.3314 10.3343 10.8944 10.0528L17 7M17 7V10"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M12 14H17M17 14L14 11M17 14L14 17"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </>,
  { viewBox: '0 0 20 20' },
);
